import React, { isValidElement, useEffect } from 'react';
import Reanimated, { useAnimatedProps, interpolate, withTiming, useSharedValue, withRepeat, Extrapolation, } from 'react-native-reanimated';
import Svg, { ClipPath, Defs, LinearGradient, Rect, Stop, } from 'react-native-svg';
const uid = () => Math.random()
    .toString(36)
    .substring(6);
const AnimatedLinearGradient = Reanimated.createAnimatedComponent(LinearGradient);
const AnimatedSvg = ({ animate = true, backgroundColor = '#f5f6f7', foregroundColor = '#eee', rtl = false, speed = 1.2, interval = 0.25, style = {}, beforeMask = null, children, ...props }) => {
    const rtlStyle = rtl ? { transform: [{ rotateY: '180deg' }] } : {};
    const svgStyle = Object.assign(Object.assign({}, style), rtlStyle);
    const fixedId = props.uniqueKey || uid();
    const idClip = `${fixedId}-diff`;
    const idGradient = `${fixedId}-animated-diff`;
    const sv = useSharedValue(-1);
    const animatedProps = useAnimatedProps(() => {
        const x1 = interpolate(sv.value, [-1, 2], [-100, 100], Extrapolation.CLAMP);
        const x2 = interpolate(sv.value, [-1, 2], [0, 200], Extrapolation.CLAMP);
        return {
            x1: `${x1}%`,
            x2: `${x2}%`,
        };
    });
    useEffect(() => {
        sv.value = withRepeat(withTiming(2, { duration: 1500 }), -1, true);
    }, []);
    return (React.createElement(Svg, { style: svgStyle, ...props },
        beforeMask && isValidElement(beforeMask) ? beforeMask : null,
        React.createElement(Rect, { x: "0", y: "0", width: "100%", height: "100%", fill: `url(#${idClip})`, clipPath: `url(#${idGradient})` }),
        React.createElement(Defs, null,
            React.createElement(ClipPath, { id: idGradient }, children),
            React.createElement(AnimatedLinearGradient, { animatedProps: animatedProps, id: idClip, x1: 0, x2: 0, y1: 0, y2: 0, onPress: () => { } },
                React.createElement(Stop, { offset: 0, stopColor: backgroundColor }),
                React.createElement(Stop, { offset: 0.5, stopColor: foregroundColor }),
                React.createElement(Stop, { offset: 1, stopColor: backgroundColor })))));
};
export default AnimatedSvg;
//# sourceMappingURL=AnimatedSvg.js.map